import { Snake } from '../server-src/model'

type Pair = [number, number]

export function getStuff(
  jointLengths: number[],
  head: [number, number],
  initialDirectionVertical: boolean,
  length: number
) {
  // let directionVertical = initialDirectionVertical
  // let coords: [number, number][] = []
  // let coord: [number, number] = [...head] as [number, number]
  //
  // let leftInDist = jointLengths[j]
  // coords.push([...coord] as [number, number])

  let directionVertical = initialDirectionVertical
  let coord: Pair = [...head] as Pair

  let j = jointLengths.length - 1
  let left = length - 1
  let stuff: Pair[] = []

  const res: [Pair, number, boolean][] = []
  while (left > 0) {
    let diff = Math.min(Math.abs(jointLengths[j]), left)
    stuff.push([left, left - diff])

    const dim = directionVertical ? 1 : 0
    const sign = jointLengths[j] > 0 ? 1 : -1

    const numToAdd = Math.floor(Math.abs(diff - (left % 1))) + 1
    const firstCoord = [...coord] as Pair
    firstCoord[dim] += (left % 1) * sign
    const lastCoord = [...firstCoord] as Pair
    lastCoord[dim] += (numToAdd - 1) * sign
    if (numToAdd > 0)
      res.push([
        firstCoord[dim] === Math.min(firstCoord[dim], lastCoord[dim])
          ? firstCoord
          : lastCoord,
        numToAdd,
        directionVertical,
      ])

    const nextJointCoord = [...coord] as Pair
    nextJointCoord[dim] += diff * sign
    left -= diff
    j -= 1
    coord = nextJointCoord
    directionVertical = !directionVertical
  }
  // console.log(res)
  return res
}

// console.log(getStuff([4, 5], [150, 20], true, 9))

export function getBoundingRects({
  jointLengths,
  head,
  initialDirectionVertical,
  length,
}: Snake) {
  const stuff = getStuff(jointLengths, head, initialDirectionVertical, length)
  // x y width height
  let headCoord: [number, number, number, number] = [head[0], head[1], 1, 1]
  let otherCoords: [number, number, number, number][] = []
  let soFar = 0
  for (let [[x, y], len, isVertical] of stuff) {
    if (soFar < 1) {
      if (isVertical) y++
      else x++
      soFar++
      len--
    }
    if (len > 0) {
      otherCoords.push([x, y, isVertical ? 1 : len, isVertical ? len : 1])
    }
  }
  return { headCoord, otherCoords }
}
